import { FC } from 'react'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'

import { Box, Typography, useTheme } from '@mui/material'
import { EventStatus } from '../../../../types/event.type'
import { EventColor } from '../../../../utils/functions'

import styles from './styles.module.scss'
import { formatDate } from '../../../../utils/dateFormatter'

interface IProps {
  text: string
  created_at: Date
  status: EventStatus
}

const EventBox: FC<IProps> = ({ text, created_at, status }) => {
  const theme = useTheme()

  const color = EventColor(status, theme)

  let IconCls

  switch (status) {
    case EventStatus.ERROR:
    case EventStatus.WARNING:
      IconCls = WarningIcon
      break
    default:
      IconCls = InfoIcon
  }

  return (
    <>
      <Box className={styles.event}>
        <IconCls sx={{ color }} />
        <Box className={styles.textContainer}>
          <Typography
            id="event"
            data-testid="event"
            className={styles.text}
            style={{ color }}
          >
            {formatDate(created_at)}: {text}
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default EventBox
